module.exports = __webpack_public_path__ + "static/media/ar-image.f53b5801.svg";